import script from "./CustomerUploadsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerUploadsPage.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerUploadsPage.vue?vue&type=style&index=0&id=71b9d5c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71b9d5c4"]])

export default __exports__